import { Injectable } from '@angular/core';
import {
  HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse
} from '@angular/common/http';
import { catchError, finalize, timeout } from 'rxjs/operators';
import { EMPTY, Observable, of, throwError} from 'rxjs';
import { Router } from '@angular/router';
import { RouteNames } from '../routing/app-routing.constants';
import { AgLoadingService } from '@ag/vc.ag-ui';
import { HelperService } from './helper.service';
import { AgAuthenticationService } from '@ag/vc.ag-core/authentication';

@Injectable()
export class HttpInterceptorsService implements HttpInterceptor {
  private totalRequests = 0;

  constructor(
    private readonly loadingService: AgLoadingService,
    private readonly router: Router,
    private readonly helper: HelperService,
    private readonly authenticationService: AgAuthenticationService
  ) { }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {   

    if (request.url.includes('signatureRequests')|| request.url.includes('AGLifeDigitalPlatform/SignatureApi')) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${this.authenticationService.accessToken}`
        }
      });
    }

    // to make sure string values are trimmed before being saved in db
    try{
      if(['POST','PUT','PATCH'].includes(request.method)){
        request.clone({
          body:this.helper.trimStringValues(request.body)
        });
      }
    }catch(e){
      console.error("Request for trimming the object could not be processed beacause:" + e);
    }

    if(request.url.indexOf('status') >1 && request.url.indexOf('AGLifeDigitalPlatform/OnlinePaymentApi') > 1 ){
      return next.handle(request).pipe(
        timeout(10000),
        catchError(err=>{
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
          if(err.name =="TimeoutError"){
          this.helper.setOnlinePaymentGetStatusTimeOut(true);
         return EMPTY;
        }else{
          throw (err);
        }
        })
      )

    }else{
      if (!(request.url.indexOf('savesimulationanswers') !== -1 && 
        request.params.get('isRuleEngine') === 'false') && 
        !(request.url.indexOf('updatesilconsents') !== -1) && 
        !(request.url.indexOf('eventlog') !== -1) && 
        !(request.url.indexOf('contractdatadetails') !== -1) && 
        !(request.url.indexOf('processordersepamandate') !== -1) &&
        !(request.url.indexOf('invalidateanswers')!== -1) &&
        !(request.url.indexOf('changebankaccount')!== -1) &&
        !(request.url.indexOf('CreateOnlinePayment')!== -1) &&
        !(request.url.indexOf('OnlinePaymentApi')!== -1) &&
        !(request.url.indexOf('online-payment-events')!== -1) &&
        !(request.url.indexOf('updateuserlanguagepreference')!== -1)) {
      this.totalRequests++;
      this.loadingService.show();
    }
    return next.handle(request).pipe(
      finalize(() => {
        if (!(request.url.indexOf('savesimulationanswers') !== -1 && 
            request.params.get('isRuleEngine') === 'false') && 
            !(request.url.indexOf('updatesilconsents') !== -1) && 
            !(request.url.indexOf('eventlog') !== -1) && 
            !(request.url.indexOf('contractdatadetails') !== -1) && 
            !(request.url.indexOf('processordersepamandate') !== -1) &&
            !(request.url.indexOf('invalidateanswers')!== -1) &&
            !(request.url.indexOf('changebankaccount')!== -1) &&
            !(request.url.indexOf('CreateOnlinePayment')!== -1) &&
            !(request.url.indexOf('OnlinePaymentApi')!== -1) &&
            !(request.url.indexOf('online-payment-events')!== -1) &&
            !(request.url.indexOf('updateuserlanguagepreference')!== -1)) {
          this.totalRequests--;
        }
        if (this.totalRequests === 0) {
          this.loadingService.hide();
        }
      }),
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401 && this.router.url.indexOf(RouteNames.eSign) === -1) {
          // TODO: a logout component should be built with all the logout logic in one place and only redirection to logout page should be done
          void this.router.navigate(['/' + RouteNames.authentication + '/' + RouteNames.logout]);          
         throw (error);
        }
        if (error.status === 403 && this.router.url.indexOf(RouteNames.eSign) === -1) {
          void this.router.navigate([`${RouteNames.blocked}`]);
          throw ((error?.error as HttpErrorResponse)?.message);
        }
        if ((error.status === 404) || (error.status === 409)) {
          return throwError(() => error);       
        }
        if(this.router.url.indexOf(RouteNames.OnlinePayment) !== -1){
          throw (error);
        }
        else if (this.router.url.indexOf(RouteNames.eSign) === -1) {
          throw ((error?.error as HttpErrorResponse)?.message);
        } else {
          // void this.router.navigate([`${RouteNames.eSign}/${RouteConstant.error}`]);
          return EMPTY;
        }
      })
    );
    }
    
    
  }
}
